﻿import { Environment } from "../TSScripts/environment";
import { Service } from "../TSScripts/service";
import { Loader } from "../TSScripts/loader";
/*import * as $ from "jquery";*/
import './jquery';
import "jquery-mask-plugin";
import "jquery-validation"
import "jquery-validation-unobtrusive";
import "bootstrap";
import { StatusBarWidget } from "./StatusBar";
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/i18n/datepicker-en-GB.js';
import 'jquery-ui/ui/i18n/datepicker-sl.js';
import { Popover } from "bootstrap";


export class ArchiveWidget {
    private element: HTMLElement;
    private service: Service;
    private statusBarWidget: StatusBarWidget;
    private debug: boolean = false;
    private Validator: JQueryValidation.Validator;
    private page: number;
    private loading: boolean;
    private endOfPage: boolean;
    private lazy: boolean = false;
    private fileName: string;

    private widgetElement: HTMLElement = null;
    private downloadDocumentUrl: string = null;
    private archiveUrl: string = null;
    private archiveLazyUrl: string = null;
    private archivePagingUrl: string = null;

    constructor(element: HTMLElement, statusBarWidget: StatusBarWidget) {
        this.element = element;
        this.service = new Service(Environment.applicationUrl, this.element);
        this.statusBarWidget = statusBarWidget;
        this.page = 0;
        this.loading = false;
        this.endOfPage = false;
        this.init();
        
    }

    initNoLoad() {
        let th = this;
        $('[data-name=btnDownload]').off("click");
        $('[data-name=btnDownload]').on("click", (ev: Event) => th.download(ev));     
        var df = "";
        if ($("[name=culture]").val().split("-")[0] == "en") df = 'en';
        if ($("[name=culture]").val().split("-")[0] == "sl") df = 'sl';
        $('#date-input').datepicker($.datepicker.regional[df]);

    }

    init() {
        let th = this;
        $('[data-onclick=backOnTopBtn]').on("click", (ev: Event) => th._scrollToTop());
        
        $("#document-name-input, #sender-input").on('keydown', function () { th.onInputChange() });
        /*$("").on('keydown', function () { th.onInputChange() });*/
        $("#date-input").on('change', function () { th.onInputChange() });
        $("#status-input").on('change', function () { th.onInputChange() });
                    
        this.widgetElement = $(".archive-widget")[0];

        this.downloadDocumentUrl = $(this.widgetElement).data("downloadDocumentUrl");
        this.archiveUrl = $(this.widgetElement).data("archiveUrl");
        this.archiveLazyUrl = $(this.widgetElement).data("archiveLazyUrl");
        this.archivePagingUrl = $(this.widgetElement).data("archivePagingUrl");

        let sm = "1";

        this.initLoading();
        this.initNoLoad();
        //this.checkPostDeletion();
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
    }

    initLoading() {
        let th = this;
        let width = $(window).width();

        
        if (width > 800) {     //desktop
            this._debugging("desktop - paging");
            th.initPagingLoad();                                                 
        } else { //mobile
            this._debugging("mobile - lazy");
            this.lazy = true;
            th.initLazyLoad();
        }
    }

    initPagingLoad() {
        this._debugging("initPagingLoad");
        $(".table-wrap nav").show();
        $('.pagination li a').off();
        $('.pagination li a').on("click", (ev: Event) => {
            ev.preventDefault();
            this.paginate($(ev.target).data("ordinal"));            
        });
        this.initNoLoad();
    }
    initLazyLoad() {
        let th = this;
        $(window).scroll(function () {
            if (!th.endOfPage) {
                if (th.loading == false) {
                    if ($(window).scrollTop() > $(document).height() - $(window).height() - $(".section.footer").height()) {
                        th.loading = true;
                        th.loadMoreData();
                    }
                }
            }
        });
    }

    //download
    download(ev: Event) {
        ev.preventDefault();
        let id = $(ev.currentTarget).data("id");
        let signed = $(ev.currentTarget).data("signed") === "True";
        let url = $(ev.currentTarget).data("url");
        this.fileName = $(ev.currentTarget).data("filename");
        if (signed) {
            this.fileName = this.fileName.replace(".pdf", ".signed.pdf");
        }
        let th = this;
        th._showLoader();
        th.getDocument(url, id).then((data: Blob) => {
            let blob = new Blob([data], { type: "application/octetstream" });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = th.fileName;
            link.click();
            this._hideLoader();

        });
    }
    getDocument(url, id) {
        try {
            this._debugging("getDocument");
            let th = this;
            return new Promise(function (resolve) {
                let self = th;
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: { idZahtevka: id },
                    cache: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    xhr: function () {
                        var xhr = new XMLHttpRequest();
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState == 2) {
                                if (xhr.status == 200) {
                                    xhr.responseType = "blob";
                                } else {
                                    xhr.responseType = "text";
                                }
                            }
                        };
                        return xhr;
                    },
                }).done((data) => resolve(data))
                    .fail((xhr, status, error) => self.service.onPostFail(xhr, status, error, self.statusBarWidget))
            });
        } catch (e) {
            console.log(e);
        }
    }

    //paging load
    paginate(page) {
        this._debugging("paginating: " + page);
        this._showLoader();
        let filters = this.getFilters();
        let url = `${this.archiveUrl}/${page}?${filters}`;
        let el = $("[data-content=table-rows]");
        el.html("");
        this.page = page;
        this._debugging(el);
        this.changeFlag(page);
        this.GetObrazec(url)
            .done((html) => this.paginateDone(html, el))
            .fail((xhr, status, error) => this.onGetFail(xhr, status, error));
    }
    changeFlag(page) {
        $(".pagination a").each(function () {
            if ($(this).data("ordinal") == page) {
                $(this).addClass("flag");
            } else {
                $(this).removeClass("flag");
            }
        })
    }
    paginateDone(html: any, el: JQuery<HTMLElement>) {
        this._debugging("paginating done");
        this._debugging(html);        
        el.html(html);
        this.initNoLoad();
        this._hideLoader();
    }

    //lazy load
    loadMoreData() {
        this._debugging("loading more data");
        this._showLoader();
        let filters = this.getFilters();
        let url = `${this.archiveLazyUrl.slice(0, -2)}/${this.page}?${filters}`;
        let el = $("[data-content=table-rows]");
        this.GetObrazec(url)
            .done((html) => { this.loadMoreDone(html, el); this.initNoLoad(); })
            .fail((xhr, status, error) => this.onGetFail(xhr, status, error));
    }

    loadMoreDone(html: any, el: JQuery<HTMLElement>) {
        this._debugging("loading done");
        this._debugging(html);
        if (html == null || html == "") this.endOfPage = true;
        el.append(html);
        this._hideLoader();
        this.page++;
        this.loading = false;
    }
    
    //filtering
    onInputChange() {
        let th = this;
        clearTimeout($(this).data('timer'))
        var timer = setTimeout(function () { th.loadData() }, 500);
        $(this).data('timer', timer);
    }
    loadData() {
        let filters = this.getFilters();
        this._debugging("filtering: " + filters);
        this._showLoader();
        this.page = 0;
        this.endOfPage = false;
        let url = `${this.archiveUrl}/${this.page}?${filters}`;
        if (this.lazy) url = `${this.archiveLazyUrl.slice(0, -2)}/${this.page}?${filters}`
        let el = $("[data-content=table-rows]");
        this.GetObrazec(url)
            .done((html) => this.loadDataDone(html, el))
            .fail((xhr, status, error) => this.onGetFail(xhr, status, error));     
    }

    loadPaging() {
        let url = this.archivePagingUrl;
        let el = $(".pagination.signt");
        this.GetObrazec(url)
            .done((html) => this.getDone(html, el))
            .fail((xhr, status, error) => this.onGetFail(xhr, status, error));
    }
    loadDataDone(html: any, el: JQuery<HTMLElement>) {
        this._debugging("loading done");
        this._debugging(html);
        if (html == null || html == "") this.endOfPage = true;
        el.html(html);
        this.page++;
        if(this.lazy==false)this.loadPaging();
        this._hideLoader();         
        this.loading = false;
    }
    getDone(html: any, el: JQuery<HTMLElement>) {
        this._debugging("load paging done");
        this._debugging(html);
        el.html(html);
        this.initLoading();
        this._hideLoader();
    }
    getFilters() {
        let nazivDokumenta = $("#document-name-input").val();
        let posiljatelj = $("#sender-input").val();             
        var dateObject = $("#date-input").datepicker("getDate");
        let datum = $.datepicker.formatDate("mm-dd-yy", dateObject);
        let status = $("#status-input").val();
        return `signJobTitle=${nazivDokumenta}&searchTerm=${posiljatelj}&datum=${datum}&status=${status}`
    }
     
    public GetObrazec(url: string) {
        return $.ajax({
            type: "GET",
            url: url,
            dataType: "html",
            contentType: 'application/x-www-form-urlencoded',
            cache: false,
            xhrFields: {
                withCredentials: true
            }
        })
    }
    //post handler
    //post(data: any, el: any, url: string) {
    //    this._debugging("posting: " + data.toString() + " to: " + url)
    //    this.service.PostObrazec(data, url)
    //        .done((html) => this.onPostDone(html, el))
    //        .fail((xhr, status, error) => this.onPostFail(xhr, status, error));
    //}
    //onPostDone(html: any, el: any) {
    //    this._debugging("post done: " + html.toString());
    //    el.html(html);
    //    this._hideLoader()
    //}
    onPostFail(xhr: JQueryXHR, status: any, error: any) {
        this.statusBarWidget.setStatus(status + ": " + this.base64Decode(xhr.getResponseHeader("err")), "bad");
        this._hideLoader();
        if (!xhr.getResponseHeader("err"))
            location.reload();
    }
    //get handler
    //get(el: JQuery<HTMLElement>, url: string) {
    //    this._debugging("getting: " + url)
    //    this.service.GetObrazec(url)
    //        .done((html) => this.onGetDone(html, el))
    //        .fail((xhr, status, error) => this.onGetFail(xhr, status, error));

    //}
    //onGetDone(html: any, el: JQuery<HTMLElement>) {
    //    this._debugging("get done");
    //    el.html(html);
    //    this.init();
    //    this._hideLoader();
    //}

    base64Decode(base64: string) {
        if (!base64) return "";
        // decode base64
        let decodedError = atob(base64);
        // decode utf-8
        try {
            return decodeURIComponent(escape(decodedError));
        } catch (e) {
            return decodedError;
        }
    }

    onGetFail(xhr: JQueryXHR, status: any, error: any) {
        this.statusBarWidget.setStatus(status + ": " + this.base64Decode(xhr.getResponseHeader("err")), "bad");
        this._hideLoader();
        if (!xhr.getResponseHeader("err"))
            location.reload();
    }

    //debugger
    _debugging(msg: any) {
        if (this.debug == true) {
            console.log(msg);
        }
    }
    _showLoader() {
        Loader.showLoader(this.element, 300);
    }

    _hideLoader() {
        Loader.hideLoader(this.element);
    }
    _scrollToTop() {
        window.scroll({ top: 0, left: 0 });
    }
}